import { useEffect } from "react";
import { StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { toast } from "react-toastify";
import { getLoginData } from "../../../../utility/AppStoreData";
import { fetchEventDetails } from "../../../../services/eventsAPI";

interface UseStreamSetupInitParams {
  eventId: string;
  loading: boolean;
  userData: any;
  setUserData: (u: any) => void;
  setAccessToken: (t: string | null) => void;
  setUserRole: (r: string | null) => void;
  navigation: any;
  setLoader: (b: boolean) => void;
  connectToEvent: (
    username: string,
    eventId: string,
    token: string,
    userRole: string
  ) => void;
  setOrganiserStreamStatus: (s: string) => void;
  setChallengerStreamStatus: (s: string) => void;
  setOrganiserLiveStart: (b: boolean) => void;
  setChallengerLiveStart: (b: boolean) => void;
  setOrganiserStreamCompleted: (b: boolean) => void;
  setChallengerStreamCompleted: (b: boolean) => void;
}

export function useStreamSetupInit({
  eventId,
  loading,
  userData,
  setUserData,
  setAccessToken,
  setUserRole,
  navigation,
  setLoader,
  connectToEvent,
  setOrganiserStreamStatus,
  setChallengerStreamStatus,
  setOrganiserLiveStart,
  setChallengerLiveStart,
  setOrganiserStreamCompleted,
  setChallengerStreamCompleted,
}: UseStreamSetupInitParams) {
  useEffect(() => {
    // Skip if already loading or if userData is already set
    if (loading || userData) return;

    const initializeLiveStream = async () => {
      const loginData = await getLoginData();
      if (!loginData) return;

      setUserData(loginData);
      setAccessToken(loginData.AccessToken);

      try {
        setLoader(true);
        const response = await fetchEventDetails(
          eventId,
          loginData.AccessToken,
          "true"
        );

        const { userRole, organiserStreamStatus, challengerStreamStatus } =
          response;
        setUserRole(userRole);

        if (userRole === "audience") {
          navigateToScreen(navigation, "GameShowScreen", { eventID: eventId });
          return;
        }

        if (userRole === "organiser") {
          setOrganiserStreamStatus(organiserStreamStatus);
          setOrganiserLiveStart(organiserStreamStatus === "live");
          setOrganiserStreamCompleted(organiserStreamStatus === "completed");
        } else if (userRole === "challenger") {
          setChallengerStreamStatus(challengerStreamStatus);
          setChallengerLiveStart(challengerStreamStatus === "live");
          setChallengerStreamCompleted(challengerStreamStatus === "completed");
        }

        connectToEvent(
          loginData.username,
          eventId,
          loginData.AccessToken,
          userRole
        );
      } catch (error: any) {
        toast.error(`Error fetching event details: ${error.message}`);
      }
    };

    initializeLiveStream();
  }, [eventId]);
}
